import { Component } from '@verndale/core';
import Chart from 'chart.js/auto';

const COLORS = ['#e09a07', '#25486b'];

class StatsGraph extends Component {
  setupDefaults() {
    this.dom = {
      canvas: this.el.querySelector('.home-statistic-card__canvas'),
      canvasContext: this.el
        .querySelector('.home-statistic-card__canvas')
        .getContext('2d')
    };

    this.chartType = this.el.dataset.chartType;
    this.chartValue = this.el.dataset.chartValue
      .trim()
      .replace(/[^0-9,]/g, '')
      .split(',');
    this.chartLabels = this.el.dataset.chartLabels;
    this.chartTitle = this.el.dataset.chartTitle;
    this.createChart = null;
    this.timeout = null;
    this.observer = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.createChart) {
            this.createChart = true;
            this.initGraph();
          }
        });
      },
      {
        threshold: 1
      }
    );
    this.observer.observe(this.dom.canvas);
  }

  getData() {
    const datasets = [];
    const portionIndex = this.chartValue.length / this.chartLabels;
    const valueArray = this.chartValue.map(value => parseInt(value, 10));

    switch (this.chartType) {
      case 'line':
        for (let i = 0; i < this.chartLabels; i++) {
          datasets.push({
            label: `Dataset ${i}`,
            data: this.chartValue.slice(
              i * portionIndex,
              portionIndex + i * portionIndex
            ),
            borderColor: COLORS[i],
            backgroundColor: COLORS[i]
          });
        }

        break;
      case 'bar':
        datasets.push({
          label: 'Dataset 0',
          data: valueArray,
          backgroundColor: COLORS[0]
        });
        datasets.push({
          label: 'Dataset 1',
          data: valueArray.map(value => 100 - value),
          backgroundColor: COLORS[1]
        });
        break;
      case 'doughnut':
        datasets.push({
          label: 'Dataset 0',
          data: [...valueArray, 100 - valueArray[0]],
          backgroundColor: COLORS
        });
        break;
      default:
        datasets.push({
          label: 'Dataset 0',
          data: this.chartValue.map(value => parseInt(value, 10)),
          backgroundColor: COLORS[0]
        });
    }

    const data = {
      labels: this.chartType === 'doughnut' ? [1, 2] : datasets[0].data,
      datasets
    };

    return data;
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  initGraph() {
    this.cutout = this.dom.canvas.offsetWidth / 2.2;
    this.chart = new Chart(this.dom.canvasContext, {
      type: this.chartType,
      data: this.getData(),
      options: {
        animation: {
          duration: 2000
        },

        borderWidth: this.chartType === 'line' ? 4 : 0,
        aspectRatio: this.chartType === 'doughnut' ? 1 : 1.6,
        responsive: true,
        cutout: this.cutout,
        tension: 0.5,
        maxBarThickness: 5,
        scaleLabel: {
          display: false
        },
        events: [],
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        scales: {
          x: {
            display: false,
            stacked: true
          },
          y: {
            display: false,
            stacked: true
          }
        },
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: false
          }
        }
      }
    });
  }

  handleResize() {
    this.cutout = this.dom.canvas.offsetWidth / 2.2;
  }
}

export default StatsGraph;
